function SelfTag() {
    return <p className='tag self'><i class="fa-regular fa-circle-user"></i> Your Post</p>;
  }

export default SelfTag;